import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'StakeholderType',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var typeListEn = [{
      header: 'Suppliers and Service Providers'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Manufacturing'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Logistics and Transportation'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Training and Development'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Software and Technology'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Utility'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Consultants and Advisory Services'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Maintenance and Repair'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Facility Management'
    }, {
      group: 'Suppliers and Service Providers',
      name: 'Marketing and Advertising'
    }, {
      divider: true
    }, {
      header: 'Employees & Workers'
    }, {
      group: 'Employees & Workers',
      name: 'Union Members'
    }, {
      group: 'Employees & Workers',
      name: 'Permanent Employees'
    }, {
      group: 'Employees & Workers',
      name: 'Freelancers'
    }, {
      group: 'Employees & Workers',
      name: 'Interns and Trainees'
    }, {
      group: 'Employees & Workers',
      name: 'Retirees'
    }, {
      group: 'Employees & Workers',
      name: 'Executives and Senior Management'
    }, {
      group: 'Employees & Workers',
      name: 'Remote Workers'
    }, {
      group: 'Employees & Workers',
      name: 'Diverse and Inclusion Groups'
    }, {
      group: 'Employees & Workers',
      name: 'Workers in the value chain'
    }, {
      divider: true
    }, {
      header: 'Customers'
    }, {
      group: 'Customers',
      name: 'Retail Customers'
    }, {
      group: 'Customers',
      name: 'Corporate / business Customers'
    }, {
      group: 'Customers',
      name: 'Potential Customers'
    }, {
      group: 'Customers',
      name: 'Past / Old Customers'
    }, {
      divider: true
    }, {
      header: 'Investors'
    }, {
      group: 'Investors',
      name: 'Institutional Investors'
    }, {
      group: 'Investors',
      name: 'Equity Shareholders'
    }, {
      group: 'Investors',
      name: 'Private Equity Firms'
    }, {
      divider: true
    }, {
      header: 'Regulatory Authorities'
    }, {
      group: 'Regulatory Authorities',
      name: 'Regulatory Bodies'
    }, {
      group: 'Regulatory Authorities',
      name: 'Banking Authorities'
    }, {
      group: 'Regulatory Authorities',
      name: 'Financial Supervisory Authority'
    }, {
      group: 'Regulatory Authorities',
      name: 'Legislative Bodies'
    }, {
      divider: true
    }, {
      header: 'Public and Media'
    }, {
      group: 'Public and Media',
      name: 'Mainstream Media'
    }, {
      group: 'Public and Media',
      name: 'Local Communities'
    }, {
      group: 'Public and Media',
      name: 'Academia and Researchers'
    }, {
      group: 'Public and Media',
      name: 'General Public'
    }, {
      group: 'Public and Media',
      name: 'Non-governmental Organizations (NGOs)'
    }, {
      group: 'Public and Media',
      name: 'Environmental and Social Activist Groups'
    }, {
      group: 'Public and Media',
      name: 'Consumer Advocacy Groups'
    }, {
      group: 'Public and Media',
      name: 'Trade and Industry Publications'
    }, {
      divider: true
    }, {
      header: 'Silent stakeholders'
    }, {
      group: 'Silent stakeholders',
      name: 'Natural environment'
    }, {
      divider: true
    }, {
      header: 'Other'
    }, {
      group: 'Other',
      name: 'Other'
    }];
    var typeListDe = [{
      header: 'Lieferanten und Dienstleister'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Fertigung'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Logistik und Transport'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Schulung und Weiterbildung'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Software und Technologie'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Versorgung'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Berater und Beratungsdienste'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Wartung und Reparatur'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Gebäudemanagement'
    }, {
      group: 'Lieferanten und Dienstleister',
      name: 'Marketing und Werbung'
    }, {
      divider: true
    }, {
      header: 'Mitarbeiter & Arbeiter'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Gewerkschaftsmitglieder'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Mitarbeiter'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Freiberufler'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Praktikanten und Auszubildende'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Rentner'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Führungskräfte und Senior Management'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Remote-Arbeiter'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Diversity- und Inklusionsgruppen'
    }, {
      group: 'Mitarbeiter & Arbeiter',
      name: 'Arbeiter in der Wertschöpfungskette'
    }, {
      divider: true
    }, {
      header: 'Kunden'
    }, {
      group: 'Kunden',
      name: 'Einzelhandelskunden'
    }, {
      group: 'Kunden',
      name: 'Unternehmens- / Geschäftskunden'
    }, {
      group: 'Kunden',
      name: 'Potenzielle Kunden'
    }, {
      group: 'Kunden',
      name: 'Ehemalige / Frühere Kunden'
    }, {
      divider: true
    }, {
      header: 'Investoren'
    }, {
      group: 'Investoren',
      name: 'Institutionelle Investoren'
    }, {
      group: 'Investoren',
      name: 'Aktieninhaber'
    }, {
      group: 'Investoren',
      name: 'Private Equity-Firmen'
    }, {
      divider: true
    }, {
      header: 'Regulierungsbehörden'
    }, {
      group: 'Regulierungsbehörden',
      name: 'Regulierungsstellen'
    }, {
      group: 'Regulierungsbehörden',
      name: 'Bankaufsichtsbehörden'
    }, {
      group: 'Regulierungsbehörden',
      name: 'Finanzaufsichtsbehörde'
    }, {
      group: 'Regulierungsbehörden',
      name: 'Gesetzgebende Stellen'
    }, {
      divider: true
    }, {
      header: 'Öffentlichkeit und Medien'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Mainstream-Medien'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Lokale Gemeinschaften'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Wissenschaft und Forscher'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Allgemeine Öffentlichkeit'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Nichtregierungsorganisationen (NGOs)'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Umwelt- und Sozialaktivistengruppen'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Verbraucherschutzorganisationen'
    }, {
      group: 'Öffentlichkeit und Medien',
      name: 'Fach- und Branchenpublikationen'
    }, {
      divider: true
    }, {
      header: 'Stumme Stakeholder'
    }, {
      group: 'Stumme Stakeholder',
      name: 'Natürliche Umwelt'
    }, {
      divider: true
    }, {
      header: 'Sonstige'
    }, {
      group: 'Sonstige',
      name: 'Sonstige'
    }];
    var typeList = computed(function () {
      var _$i18n$localeProperti;
      return ((_$i18n$localeProperti = $i18n.localeProperties) === null || _$i18n$localeProperti === void 0 ? void 0 : _$i18n$localeProperti.code) === 'de' ? typeListDe : typeListEn;
    });
    return {
      __sfc: true,
      $i18n: $i18n,
      typeListEn: typeListEn,
      typeListDe: typeListDe,
      typeList: typeList
    };
  }
});